(function() {
    'use strict';
    angular
        .module('quantixApp')
        .controller('CompanyReportClientAdminController', CompanyReportClientAdminController);

        CompanyReportClientAdminController.$inject = ['$scope', '$filter', 'CompanyReportService', '$window'];

    function CompanyReportClientAdminController($scope, $filter, CompanyReportService, $window) {
        var userGrid = '';
        var editableGrid = ''
        $scope.message = '';
        $scope.isEdit = false;
        
        $scope.userGridCompletion = function(event) {
            userGrid = event.target;
            userGrid.validateNow();
        }
        $scope.editableGridCompletion = function(event) {
            editableGrid = event.target;
            editableGrid.validateNow();
        }

        $scope.getClientAssociateUsers = function() {
            CompanyReportService.getClientAssociateUsers().then(function(response) {
                    $scope.subscriptionsObj = response;
                    $scope.userGrid = {
                        dataProvider : response.users,
                        delegate : $scope
                    };
                    $scope.editableGrid = {
                        dataProvider : response.users,
                        delegate : $scope
                    };
                }, function(error) {}
            );
        }

        $scope.getEditableField = function(rowData, column) {
            var html = '';
            if($scope.subscriptionsObj.subscriptionLimit >= 10000000) {
                html= '<input class="form-control" oninput="formatLimit(this)" step="1" id="editField'+rowData.id+'" type="number">'
            } else {
                html= '<input class="form-control" oninput="formatLimit(this)" step="1" id="editField'+rowData.id+'" type="number" value="'+ rowData.userLimit +'">'
            }
            return html;
        }

        $scope.editLimit = function() {
            $scope.isEdit = true;
        }

        $scope.getDownloadLimit = function(rowData, column) {
            return $scope.subscriptionsObj.subscriptionLimit >= 10000000 ? 'Unlimited' : rowData.userLimit;
        }

        $scope.isLimitedSusbcription = function() {
            return $scope.subscriptionsObj.subscriptionLimit < 10000000;
        }

        $scope.saveLimit = function() {
            $scope.message = '';
            $scope.isError = false;
            var clientsArray = [];
            for (var index = 0; index < $scope.userGrid.dataProvider.length; index++) {
	if(null != document.getElementById('editField' + $scope.userGrid.dataProvider[index].id)){
                var item = document.getElementById('editField' + $scope.userGrid.dataProvider[index].id).value;
                if (item && item != null) {
                    if ($scope.userGrid.dataProvider[index].userLimit != item) {
                        if(item < $scope.userGrid.dataProvider[index].reportsDownloaded + $scope.userGrid.dataProvider[index].newCompanyRequest) {
                            $scope.message = 'Please note, ‘Download Limit’ cannot be less than ‘Company Reports Downloaded’';
                            $scope.isError = true;
                        } else {
                            var obj = $scope.userGrid.dataProvider[index];
                            clientsArray.push({
                                id: obj.id,
                                clientId :obj.clientId,
                                clientName: obj.clientName,
                                userName: obj.userName,
                                email: obj.email,
                                userType: obj.userType,
                                reportsDownloaded: obj.reportsDownloaded,
                                userLimit: item,
                                newCompanyRequest: obj.newCompanyRequest
                            });
                        }
                    }
                }
                }
            }
            if(!$scope.isError) {
                CompanyReportService.updateAssociateUsersLimit(clientsArray)
                    .then(function(response) {
                        $scope.message = response.data;
                        $scope.isError = false;
                        $scope.getClientAssociateUsers();
                        $scope.isEdit = false;
                    }, function(error) {
                        $scope.isEdit = false;
                        $scope.message = error.data;
                        $scope.isError = true;
                    }
                );
            }
        }
        $window.formatLimit = function(input){
            if(input.value < 0) input.value=Math.abs(input.value);
        }
        $scope.cancel = function() {
            $scope.isEdit = false;
        }

        $scope.closeAlert = function() {
            $scope.message = '';
        }

        $scope.getDate = function(rowData, column) {
            return $filter('date')(rowData.subscriptionExpiry,'dd-MMM-yyyy');
        }
    }
})();